import React, { useContext, useEffect, useState } from 'react'
import { Input, DropList } from '../../UIcomponent/Form'
import Col from '../../UIcomponent/Column'
import StyledButton from '../../UIcomponent/Button'
import Text from '../../UIcomponent/Text'
import CountryData from '../../Utility/CountryData'
import { ThemeContext } from 'styled-components'
import sortDown from '../../Assets/icon/sortDown.svg'
import { PersianDigitReplacer } from '../../Utility/Method/PersianDigitReplacer'
const LoginForm = (props) => {
    const [showList, setShowList] = useState(false)
    const { flowType, formikProps, formik, formErrosStyle, State, setState, lang, info, setInfo } = props
    const [countries, setCountries] = useState(CountryData)
    const theme = useContext(ThemeContext)
    useEffect(() => {
    }, [])
    const onChangeFilter = (value, data, setState, filterKey1, filterKey2) => {
        let filterState = data.filter(each => (`${'+' + each[`${filterKey1}`]}`.toLowerCase().includes(value.toLowerCase()) || `${each[`${filterKey2}`]}`.toLowerCase().includes(value.toLowerCase())) && each)
        if (value.length !== 0) {
            setState(filterState)
        } else {
            setState(data)
        }
    }
    const SwithToForgotPassword = () => {
        setState({ ...State, mode: 'forgotPassword' })
        formik.resetForm()
    }
    return (
        <>
            {State.hasVerifyCode === false &&
                <>
                    {flowType === 'mobile' &&

                        <Col
                            xl={24} lg={24} md={24} sm={24} xs={24}
                            style={{
                                justifyContent: 'space-between'
                            }}

                        >
                            <Col
                                xl={17} lg={17} md={16} sm={16} xs={16}
                                style={{
                                    flexDirection: 'column',
                                }}
                            >
                                <Input
                                    lang={lang}
                                    name='mobile'
                                    lable='mobile'
                                    tabIndex={1}
                                    onChange={(e) => formikProps.setFieldValue('mobile', PersianDigitReplacer(e.target.value))}
                                    validateonchange={true}
                                    validateonBlur={true}
                                    autocomplete={'username'}
                                    type='text'
                                    placeholder='شماره موبایل'
                                    value={formikProps.values.mobile}
                                />
                            </Col>
                            <Col
                                xl={6} lg={5} md={5} sm={5} xs={7}
                                style={{
                                    justifyContent: 'flex-end'
                                }}
                            >

                                <DropList
                                    lang={'en'}
                                    show={showList}
                                    clicked={showList}
                                    letterSpace='3px'
                                    justifyContent='center'
                                    autocomplete="off"
                                    type='tel'
                                    width='45px'
                                    value={formik.values.phoneCode}
                                    disabled={State.hasVerifyCode}
                                    id='phoneCode'
                                    name='phoneCode'
                                    tabIndex={-1}
                                    onChange={(e) => {
                                        formik.setFieldValue('phoneCode', PersianDigitReplacer(e.target.value))
                                        onChangeFilter(e.target.value, CountryData, setCountries, 'phoneCode')
                                    }}
                                    icon={sortDown}
                                    contentStyle={{
                                        width: '350%',
                                        left: '0px',
                                        top: '65px',
                                    }}
                                    onClick={() => setShowList(true)}
                                    onClose={() => setShowList(false)}>
                                    {showList && countries.length > 0 && countries.map((each, index) => {
                                        return (
                                            <Col
                                                xl={24} lg={24} md={24} sm={24} xs={24}
                                                style={{
                                                    justifyContent: 'space-evenly',
                                                    minHeight: '35px',
                                                    height: '35px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    formik.setFieldValue('phoneCode', `+${each.phoneCode}`)
                                                    setTimeout(() => setShowList(false), 0)
                                                    setTimeout(() => {
                                                        setInfo({
                                                            ...info,
                                                            phoneCode: `+${each.phoneCode}`
                                                        })
                                                    }, 1)
                                                }}
                                            >
                                                <Col
                                                    xl={8} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        width: '25px',
                                                        height: '25px',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'none',
                                                        backgroundImage: `url(https://www.countryflags.io/${each.code.toLowerCase()}/shiny/64.png)`
                                                    }}
                                                ></Col>
                                                <Col
                                                    xl={8} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        opacity: '0.7',
                                                        height: '100%',
                                                        fontSize: theme.fontSizeSm,
                                                        justifyContent: 'flex-end'
                                                    }}
                                                >
                                                    {each.value}
                                                </Col>
                                                <Col
                                                    xl={4} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        opacity: '0.7',
                                                        fontSize: theme.fontSizeMd,
                                                        fontWeight: 800,
                                                        justifyContent: 'flex-end'
                                                    }}
                                                >{each.phoneCode}+</Col>
                                            </Col>
                                        )
                                    })
                                    }
                                    {
                                        showList && countries.length === 0 &&
                                        <Col>
                                            موردی یافت نشد
                                </Col>
                                    }

                                </DropList>

                            </Col>
                        </Col>
                    }
                    {flowType === 'email' &&
                        <Input
                            tabIndex={2}
                            lang={lang}
                            name='email'
                            lable='email'
                            onChange={(e) => formikProps.setFieldValue('email', e.target.value)}
                            validateOnChange={true}
                            type='email'
                            placeholder='ایمیل'
                            autocomplete={'username'}
                            // autocomplete={flowType === 'email' ? 'username' : 'email'}
                            value={formikProps.values.email}
                        />
                    }
                    <Col
                        xl={24} lg={24} md={24} sm={24} xs={24}
                    >
                        <Col
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            style={formErrosStyle('flex-start')}
                        >{flowType === 'mobile' && formik.touched.mobile && formik.errors.mobile ? formik.errors.mobile :
                            flowType === 'email' && formik.touched.email && formik.errors.email ? formik.errors.email : ''}</Col>
                        <Col
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            style={formErrosStyle('flex-end')}
                        >{formik.errors.phoneCode}</Col>

                    </Col>
                    <Input
                        lang={lang}
                        id='pass'
                        name='pass'
                        type='password'
                        tabIndex={3}
                        placeholder='رمز عبور'
                    />
                    <Text
                        style={formErrosStyle(formikProps.touched.pass)}
                    >{formikProps.touched.pass && formikProps.errors.pass}</Text>
                    <Col
                        style={{
                            marginTop: '15px'
                        }}
                        xl={24} lg={24} md={24} sm={24} xs={24}
                    >
                        <Col
                            style={{
                                color: theme.primary,
                                justifyContent: 'flex-start',
                                padding: '1px 0px 10px 0px',
                                fontSize: theme.fontSizeSm,
                                fontWeight: 600,
                                cursor: 'pointer'
                            }}
                            xl={24} lg={24} md={24} sm={24} xs={24}
                            onClick={SwithToForgotPassword}
                        >
                            {State.mode === 'forgotPassword' ? 'ورود | ثبت نام' : 'رمز عبور خود را فراموش کرده ام'}
                        </Col>
                    </Col>
                </>
            }
            <StyledButton
                style={
                    {
                        marginTop: '5px',
                        fontWeight: 800,
                        fontSize: theme.fontSizelg,
                        backgroundColor: theme.secondary,
                        color: theme.white
                    }
                }
                id='login_button'
                secondary
                width={'100%'}
                height='45px'
                loading={formik.isSubmitting}
                disable={formik.isValid === false}
                type='submit'
            >
                ورود
                            </StyledButton>
        </>

    )
}


export default LoginForm
